import axios from 'axios';

export const resolveBaseUrl = () => process.env.REACT_APP_API_URL || 'https://its-app-dec4a85b0223.herokuapp.com/api';

// Persist both tokens so protected routes survive full page reloads in production.
let accessToken = localStorage.getItem('itc_access');

export const setAccessToken = (token) => {
  accessToken = token || null;
  if (token) {
    localStorage.setItem('itc_access', token);
  } else {
    localStorage.removeItem('itc_access');
  }
};
export const getAccessToken = () => accessToken || localStorage.getItem('itc_access');
export const setRefreshToken = (token) => {
  if (token) {
    localStorage.setItem('itc_refresh', token);
  } else {
    localStorage.removeItem('itc_refresh');
  }
};
export const getRefreshToken = () => localStorage.getItem('itc_refresh');
export const clearTokens = () => {
  accessToken = null;
  localStorage.removeItem('itc_access');
  localStorage.removeItem('itc_refresh');
};

const client = axios.create({ baseURL: resolveBaseUrl() });

// Attach JWT to every request
client.interceptors.request.use((config) => {
  config.baseURL = resolveBaseUrl();
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-refresh on 401
client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refresh = getRefreshToken();
      if (!refresh) {
        clearTokens();
        window.location.href = '/login';
        return Promise.reject(error);
      }
      try {
        const { data } = await axios.post(`${resolveBaseUrl()}/auth/refresh/`, { refresh });
        setAccessToken(data.access);
        original.headers.Authorization = `Bearer ${data.access}`;
        return client(original);
      } catch {
        clearTokens();
        window.location.href = '/login';
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default client;
